import { Store } from '@/store'

export const decrementMessagesLeft = () => {
	Store.setState(draft => {
		draft.messageQuota.count = draft.messageQuota.count - 1
		draft.messageQuota.lastMessageDate = Date.now()
	})
}

export const useMessageQuota = () => {
	const messagesLeft = Store.useBoundStore(s => s.messageQuota.count)
	return { messagesLeft }
}
